import {
	getAllExternalReferencesProperties,
	type ExternalReferenceProperties,
} from './external-reference-property.tsx';
import { createIssueHook } from './utils.tsx';

export const useAllExternalReferencePropertiesOnIssues =
	createIssueHook<ExternalReferenceProperties>(getAllExternalReferencesProperties);
